import { noto_sans, ubuntu } from '@/globalConstants';
import { FestivalFaq } from '@/lib/festivalMeta';

// Festival-specific questions (built in festivalMeta.ts from the festival's own
// data). Each answer is in the HTML even while collapsed — <details> keeps
// closed content in the page, so crawlers and LLMs read every answer, and the
// FAQPage JSON-LD built from the same list matches the visible text.
const FestivalFAQ = ({ faqs, heading = 'Frequently Asked Questions' }: { faqs: FestivalFaq[]; heading?: string }) => (
    <section className="w-full bg-white rounded-[8px] border-[1px] border-[#E5E0DF] p-4 md:p-6 shadow-sm">
        <h2 className={`${ubuntu.className} text-[22px] md:text-[26px] font-[600] text-[#1D4749] mb-5`}>
            {heading}
        </h2>

        <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
                <details
                    key={faq.question}
                    open={index === 0}
                    className="group rounded-[12px] border border-[#EDE4DD] bg-white overflow-hidden"
                >
                    <summary className="w-full flex items-center justify-between gap-3 px-4 py-4 text-left cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                        <h3 className={`${noto_sans.className} text-[15px] md:text-[16px] font-[600] text-[#0F4B4A]`}>
                            {faq.question}
                        </h3>
                        <span
                            className="shrink-0 w-[24px] h-[24px] flex items-center justify-center rounded-full bg-[#FDF8E9] text-[#EE9322] transition-transform duration-200 group-open:rotate-180"
                            aria-hidden="true"
                        >
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                    </summary>
                    <div className="px-4 pb-4">
                        <p className={`${noto_sans.className} text-[14px] md:text-[15px] text-[#3C3838] leading-6`}>
                            {faq.answer}
                        </p>
                    </div>
                </details>
            ))}
        </div>
    </section>
);

export default FestivalFAQ;
